import React, { useEffect, useState } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';

import '../choose-plan/plan.scss';
import { stopBackgroundScrolling } from '../../../common/utils/app.utils';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Input from 'b2b-ui-components-lib/lib/components/input';
import HardwareList from '../choose-plan/hardware-list';
import { faOnDedicatedChangeRouterPopupLoad, faOnDedicatedChangeRouterPopupSubmit } from '../../services/analytics.service';

const RouterPopup = ({
  planSpecificRouter,
  selectedHardwareType,
  setHardwareType,
  commercialAttribute,
  closeRouterPopup,
  routerSpecsMake,
  routerSpecsModel,
  routerIndex,
  changeetRouterValue,
  itemCode,
  setItemCode
}) => {
  let routerListArray = routerSpecsMake && routerSpecsMake.map((item) => ({ displayName: item, key: item }));
  let getRouterSpecsModelData = Object.assign({}, routerSpecsModel);
  let [routerList, setRouterList] = useState(routerListArray ? routerListArray : []);
  let [routerListModel, setRouterModelList] = useState([]);
  const [selectedRouterValue, setRouterValue] = useState(routerListArray && routerListArray.length > 0 && routerListArray[0]);
  const [selectedRouterModel, setRouterModel] = useState({});
  const [routerSpecsModelData, setRouterSpecsModelData] = useState(getRouterSpecsModelData);
  const [changeHardwareTypeValue, setChangeHardwareTypeValue] = useState(changeHardwareTypeValue && changeHardwareTypeValue.value ? changeHardwareTypeValue : selectedHardwareType);
  let [cpe, setCpe] = useState([]);
  let [cpeSpecification, setCpeSpecification] = useState([]);
  const onChange = (value) => {
    setRouterValue(value);
  };
  const onChangeModel = (value) => {
    setRouterModel(value);
  };
  const closePopup = () => {
    stopBackgroundScrolling(false);
    closeRouterPopup();
  };
  useEffect(() => {
    changeHardwareType(changeHardwareTypeValue);
  }, [changeHardwareTypeValue]);
  const changeHardwareType = (value) => {
    if (value && value.value === 'NON_STANDARD') {
      let getcpeSpecification = cpeSpecification && cpeSpecification.length > 0 ? cpeSpecification : commercialAttribute && commercialAttribute.cpeSpecification;
      let getCpe = cpe && cpe.length > 0 ? cpe : commercialAttribute && commercialAttribute.cpe;
      let getMakesList = getCpe && getCpe.map((item) => ({ displayName: item, key: item }));
      setRouterSpecsModelData(getcpeSpecification);
      setRouterList(getMakesList ? getMakesList : []);
      setRouterValue(getMakesList && getMakesList.length > 0 && getMakesList[0]);
    } else {
      if (planSpecificRouter && Object.keys(planSpecificRouter).length) {
        let getMakesArray = Object.keys(planSpecificRouter);
        let getMakesObject = getMakesArray && getMakesArray.length > 0 && getMakesArray.map((item) => ({ displayName: item, key: item }));
        setRouterSpecsModelData(planSpecificRouter);
        setRouterList(getMakesObject ? getMakesObject : []);
        setRouterValue(getMakesObject && getMakesObject.length > 0 && getMakesObject[0]);
      } else {
        setRouterSpecsModelData(routerSpecsModel);
        setRouterList(routerListArray ? routerListArray : []);
        setRouterValue(routerListArray && routerListArray.length > 0 && routerListArray[0]);
      }
    }
  };
  const submitRoutersValue = () => {
    let getSelectedRouter = {};
    if (selectedRouterModel && selectedRouterModel.key) {
      getSelectedRouter.model = selectedRouterModel.key;
    }
    if (selectedRouterValue && selectedRouterValue.key) {
      getSelectedRouter.make = selectedRouterValue.key;
    }
    if (selectedRouterModel && selectedRouterModel.cost) {
      getSelectedRouter.cost = selectedRouterModel.cost;
    }
    if (selectedRouterModel && selectedRouterModel.commercial) {
      getSelectedRouter.commercial = selectedRouterModel.commercial;
    } else {
      getSelectedRouter.commercial = false;
    }
    if (selectedRouterModel && selectedRouterModel.linkType) {
      getSelectedRouter.linkType = selectedRouterModel.linkType;
    }
    setHardwareType(changeHardwareTypeValue);
    changeetRouterValue(getSelectedRouter, routerIndex);
    closePopup();
    faOnDedicatedChangeRouterPopupSubmit();
  };
  useEffect(() => {
    stopBackgroundScrolling(true);
  }, []);
  useEffect(() => {
    if (selectedRouterValue && selectedRouterValue.key) {
      let setRouterModelListArray =
        routerSpecsModelData &&
        routerSpecsModelData[selectedRouterValue.key] &&
        routerSpecsModelData[selectedRouterValue.key].map((item) => ({
          displayName: item.model ? item.model : item,
          key: item.model ? item.model : item,
          cost: item.cost ? item.cost : 0,
          commercial: item.commercial ? item.commercial : false,
          linkType: item.linkType ? item.linkType : 'PRIMARY'
        }));
      setRouterModelList(setRouterModelListArray);
      setRouterModel(setRouterModelListArray && setRouterModelListArray.length > 0 && setRouterModelListArray[0] ? setRouterModelListArray[0] : {});
    }
    faOnDedicatedChangeRouterPopupLoad();
  }, [selectedRouterValue]);
  return (
    <div className="routerPopup">
      <div className="contentpopup">
        <h3 className="router-head">Change Router</h3>
        <p className="routercontent">To change a router, choose a CPE type and it’s specification.</p>
        <div className="inputSection">
          <div className="row">
            <div className="flg-lg-12">
              <HardwareList
                changeHardwareType={changeHardwareType}
                setHardwareType={setChangeHardwareTypeValue}
                selectedHardwareType={changeHardwareTypeValue && changeHardwareTypeValue.value ? changeHardwareTypeValue : selectedHardwareType}
                commercialAttribute={commercialAttribute}
                setCpe={setCpe}
                setCpeSpecification={setCpeSpecification}
              />
              {changeHardwareTypeValue && changeHardwareTypeValue.value === 'NON_STANDARD' && (
                <p className="routercontent non-standard-hardware-info">Additional charges may apply if non-standard hardware is selected.</p>
              )}
            </div>
          </div>
        </div>
        <div className="inputSection">
          <div className="row">
            <div className="flg-lg-6 flg-md-6 flg-sm-12 inputrow">
              <div className="inputBox1">
                <Select placeholder="Router Type" value={selectedRouterValue} onChange={onChange} options={routerList} required touched />
              </div>
            </div>
            <div className="flg-lg-6 flg-md-6 flg-sm-12 inputrow">
              <div className="inputBox">
                <Select placeholder="Router Specification" value={selectedRouterModel} onChange={onChangeModel} options={routerListModel} required touched />
              </div>
            </div>
          </div>
        </div>
        {changeHardwareTypeValue?.value === 'NON_STANDARD' && (
          <div className="inputSection">
            <div className="row">
              <div className="flg-lg-6 flg-md-6 flg-sm-12 inputrow">
                <Input name="itemCode" label="Item Code" value={itemCode} onChange={(value) => setItemCode(value)} required />
              </div>
            </div>
          </div>
        )}
        <div className="bottomsection">
          <Button variant="outlinebtn" onClick={closePopup}>
            Cancel
          </Button>
          <Button variant="activebtn" onClick={submitRoutersValue} disabled={changeHardwareTypeValue?.value === 'NON_STANDARD' && !itemCode}>
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};
export default RouterPopup;
